import React, { useEffect, useState } from 'react'
import SideMenu, { IMenuItemProps } from '../side_menu'
import ConfigIcon from '../../assets/images/settings_icon.png'
import { t } from '../../adapters/translate/translate'
import SoundOn from '../../assets/images/sound-on.png'
import SaveIcon from '../../assets/images/save-icon.png'
import SoundOff from '../../assets/images/sound-off.png'
import GalleryIcon from '../../assets/images/photo.png'
import HomeIcon from '../../assets/icons/svg/home.svg'
import InstructionsIcon from '../../assets/images/info.png'
import { useNavigate, useLocation } from 'react-router-dom'
import { useGallery, useGame, usePage, useGameWrapper } from '../../contexts'
import { getAssetUrl } from '../../utils/assets_helpers'
import { isMobile } from '../../utils/general'

const initialMenu = [
  {
    imageURL: ConfigIcon,
    tooltip: 'Menu',
    onAction: () => {},
    height: '40',
    width: '40'
  }
]

type Props = {
    mobile?: boolean
  }

const Settings = ({ mobile }: Props) => {
  const [menuItemsConfig, setMenuItemsConfig] = useState<IMenuItemProps[]>([...initialMenu])
  const navigate = useNavigate()
  const location = useLocation()
  const { handleToggleGallery, images } = useGallery()
  const { isTogether, setTeamRecovery, game } = useGame()
  const { soundActivated, toggleGeneralSound, toggleInstructions, headerConfig, hasBackButton, toggleDocument } = usePage()
  const { currentMission } = useGameWrapper()

  function handleGoToHome () {
    if (isTogether() && location.pathname === '/mission') {
      navigate('/')
    }
  }

  function handleGoDocument () {
    if (isMobile()) {
      window.open(getAssetUrl('documentAttachment', game?.documentAttachment))
    } else {
      toggleDocument()
    }
  }

  const menuWithBackButton = [
    {
      imageURL: ConfigIcon,
      tooltip: 'Menu',
      name: 'menu',
      onAction: () => {},
      height: '40',
      width: '40'
    },
    {
      imageURL: HomeIcon,
      tooltip: t('See missions'),
      name: 'home',
      onAction: handleGoToHome,
      height: '40',
      width: '40'
    },
    {
      imageURL: InstructionsIcon,
      tooltip: t('Instructions'),
      name: 'instructions',
      onAction: toggleInstructions,
      height: '40',
      width: '40'
    },
    {
      imageURL: soundActivated ? SoundOn : SoundOff,
      tooltip: t('Audio: on/off'),
      name: soundActivated ? 'soundOn' : 'soundOff',
      onAction: toggleGeneralSound
    }
  ]

  if (images.length) {
    menuWithBackButton.splice(1, 0, {
      imageURL: GalleryIcon,
      tooltip: t('Gallery'),
      name: 'gallery',
      onAction: handleToggleGallery,
      height: '40',
      width: '40'
    })
  }

  if (game?.documentAttachment) {
    menuWithBackButton.splice(1, 0, {
      imageURL: GalleryIcon,
      tooltip: t('File'),
      name: 'file',
      onAction: handleGoDocument,
      height: '40',
      width: '40'
    })
  }

  if (!isTogether()) {
    menuWithBackButton.push({
      imageURL: SaveIcon,
      tooltip: t('Recovery game'),
      name: 'recovery',
      onAction: () => setTeamRecovery(true)
    })
  }

  function toggleMenu () {
    const menuWithoutBackButton = menuWithBackButton.filter(menu => menu.name !== 'home')
    if (hasBackButton) {
      setMenuItemsConfig(menuWithBackButton)
    } else {
      setMenuItemsConfig(menuWithoutBackButton)
    }
  }

  function loadMenuItems () {
    toggleMenu()
  }

  useEffect(() => {
    loadMenuItems()
  }, [soundActivated, headerConfig, hasBackButton])

  return (<div>
    <SideMenu items={menuItemsConfig} mobile={mobile} home={!currentMission} />
  </div>)
}

export default Settings
